import { api } from '../api';

function serialize(params) {
  return { ...params, config: JSON.stringify(params.config) };
}

export const imageTemplateService = {
  async fetchTemplates(params) {
    return api.get('image-templates', { params });
  },

  async createTemplate(params) {
    return api.post('image-templates', serialize(params));
  },

  async updateTemplate(id, params) {
    return api.post('image-templates/' + id, { '_method': 'PUT', ...serialize(params) });
  },

  async deleteTemplate(id) {
    return api.delete('image-templates/' + id);
  },

  /* source: { type: 'preset', key } ou { type: 'saved', id }; null remove o padrão. */
  async setDefault(format, source) {
    const params = { '_method': 'PUT', format };

    if (source) {
      params.type = source.type;

      if (source.type === 'preset') {
        params.key = source.key;
      } else {
        params.id = source.id;
      }
    }

    return api.post('image-templates/default', params);
  },
};
